import React, { useState } from 'react';
import { object, string } from 'prop-types';
import Hero from './components/Hero/Hero';
import Articles from './components/Articles/Articles';
import BreadcrumbsSemanticMarkup from '@components/BreadcrumbsMarkup/BreadcrumbsMarkup';
import style from './BlogPage.module.scss';
import SignUpSection from './components/SignUpSection/SignUpSection';
import { graphql, useStaticQuery } from 'gatsby';

const BlogPage = ({
  content,
  canonical,
  metatitle,
  type,
  categoryTitle,
  lang,
}) => {
  const [newsearch, setNewSearch] = useState();
  const [tagnewsearch, setTagNewSearch] = useState();

  const {
    title,
    buttontext,
    filtersbuttontext,
    placeholder,
    subtitle,
    body,
  } = content.allPrismicBlogpage.edges[0]?.node.data;

  const articlesList = content.allPrismicBlogpostpage.edges;
  const signUp = content.allPrismicBlogpage.edges[0]?.node.data?.body;
  const signUpSectionData = signUp?.find(
    (item) => item.slice_type === 'signup'
  );

  const handleInputChange = (e) => {
    setNewSearch(e);
  };
  const handleSearchInputChange = (e) => {
    setNewSearch();
    setTagNewSearch(e);
  };

  const filteredArticles = articlesList?.filter(({ node }) => {
    const searchData = JSON.stringify({
      uid: node?.uid,
      tags: node?.tags,
      title: node?.data?.title,
    }).toLowerCase();
    return searchData.includes(newsearch?.toLowerCase());
  });
  const filteredArticlesWithTag = articlesList?.filter(({ node }) => {
    const searchData = JSON.stringify({
      tags: node?.tags,
    }).toLowerCase();

    return searchData.includes(tagnewsearch?.toLowerCase());
  });

  const CategoryData = useStaticQuery(graphql`
    query MyQuery($uid: String, $lang: String) {
      allPrismicCategory(filter: { uid: { eq: $uid }, lang: { eq: $lang } }) {
        edges {
          node {
            uid
            type
            lang
            id
            alternate_languages {
              id
              lang
              type
              uid
            }
            data {
              category_name {
                text
              }
              category_type {
                text
              }
            }
          }
        }
      }
    }
  `);

  return (
    <div className={style.HomePage}>
      <div className={style.container}>
        <Hero
          articles={articlesList}
          filtersbuttontext={filtersbuttontext}
          isCategory={type}
          content={content}
          categoryTitle={categoryTitle}
          handleInputChange={handleInputChange}
          handleSearchInputChange={handleSearchInputChange}
          body={body}
          setNewSearch
          categoryEdges={CategoryData.allPrismicCategory.edges}
          lang={lang}
        />
        <Articles
          title={title}
          articlesList={articlesList}
          buttontext={buttontext}
          categoryTitle={categoryTitle}
          subtitle={subtitle}
          placeholder={placeholder}
          filtersbuttontext={filtersbuttontext}
          isCategory={type}
          newsearch={newsearch}
          tagnewsearch={tagnewsearch}
          filteredArticles={filteredArticles}
          filteredArticlesWithTag={filteredArticlesWithTag}
        />

        {/* {subscribeSection && <Subscribe primary={subscribeSection.primary} />} */}
        <BreadcrumbsSemanticMarkup
          pageTitle={metatitle.text}
          pageUrl={canonical.text}
        />
      </div>
      {signUpSectionData && <SignUpSection data={signUpSectionData} />}
    </div>
  );
};

BlogPage.propTypes = {
  content: object,
  canonical: object,
  metatitle: object,
  filtersbuttontext: object,
  placeholder: object,
  subtitle: object,
  type: object,
  categoryTitle: object,
  lang: string,
};

export default BlogPage;
